const BASE_CONST = 'REPORTS_TRANSACTIONS_V2';

export const REPORTS_TRANSACTIONS_PAGE_REQUEST = `${BASE_CONST}_PAGE_REQUEST`;
export const REPORTS_TRANSACTIONS_ON_SEARCH = `${BASE_CONST}_ON_SEARCH`;
export const REPORTS_TRANSACTIONS_ON_REACH_BOTTOM = `${BASE_CONST}_ON_REACH_BOTTOM`;

export const REPORTS_TRANSACTIONS_SET_ORDERS_BY_DATE = `${BASE_CONST}_SET_ORDERS_BY_DATE`;
export const REPORTS_TRANSACTIONS_SET_ORDER_SUMMARY = `${BASE_CONST}_SET_ORDER_SUMMARY`;
export const REPORTS_TRANSACTIONS_SET_NEXT_CURSOR = `${BASE_CONST}_SET_NEXT_CURSOR`;
export const REPORTS_TRANSACTIONS_SET_HAS_MORE = `${BASE_CONST}_SET_HAS_MORE`;
export const REPORTS_TRANSACTIONS_SET_OUTLET_BY_ID = `${BASE_CONST}_SET_OUTLET_BY_ID`;
export const REPORTS_TRANSACTIONS_SET_PAYMENT_METHODS = `${BASE_CONST}_SET_PAYMENT_METHODS`;
export const REPORTS_TRANSACTIONS_GET_ORDER_DETAIL = `${BASE_CONST}_GET_ORDER_DETAIL`;
export const REPORTS_TRANSACTIONS_SET_ORDER_DETAIL = `${BASE_CONST}_SET_ORDER_DETAIL`;
export const REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST = `${BASE_CONST}_REFUND_BREAKDOWN_ISSUE_REFUND_REQUEST`;
export const REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS = `${BASE_CONST}_REFUND_BREAKDOWN_SET_REFUND_ITEMS`;
export const REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO = `${BASE_CONST}_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO`;
export const REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY = `${BASE_CONST}_CONFIRM_SET_QUANTITY`;
